module.exports = __webpack_public_path__ + "img/underWriteMeLogo5.6b2bb6bd.png";